import { memo } from "react";
import { toClassName } from "../../../utils/style.utils";

interface Props {
  data: string;
  title: string;
  theme?: keyof typeof themes;
}

const themes = {
  light: {
    text: "text-black",
    subtitle: "text-day-base-base-400",
    background: "bg-white",
  },
  dark: {
    text: "text-white",
    subtitle: "text-night-base-base-400",
    background: "",
  },
};

export const Description = memo<Props>(
  ({ theme = "light", data, title, ...props }) => {
    const currentTheme = themes[theme];

    return (
      <div
        {...props}
        className={toClassName(
          "pl-3 pr-3 lg:pr-0 lg:pl-0 pb-24 lg:pb-40",
          currentTheme.background
        )}
      >
        <div className="relative">
          <span
            className={toClassName(
              "block pb-6 text-[16px] leading-[130%] lg:[18px] lg:leading-[132%] lg:pb-0 lg:inline lg:absolute top-[12px]",
              currentTheme.subtitle
            )}
          >
            {title}
          </span>
          <span className="hidden lg:inline lg:pl-51 text-[34px] leading-[43px]"></span>
          <span
            className={toClassName(
              "text-[20px] leading-[30px] lg:text-[32px] lg:leading-[40px]",
              currentTheme.text
            )}
            // eslint-disable-next-line
            dangerouslySetInnerHTML={{
              __html: data,
            }}
          />
        </div>
      </div>
    );
  }
);
